import React, { useEffect, useState } from "react";
import { Modal, Box } from "@mui/material";
// import {  useForm } from "react-hook-form";
import { useForm } from "react-hook-form";

import { saveTrainingScheduleCompletion } from "../../services/TrainingServices";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import InputField from "../../../common/components/FormFields/InputField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import { successAlert } from "../../../common/components/Toasts/CustomToasts";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "78%",
  maxHeight: "75vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 2,
};

const userActions = [
  { permission: "Delete", isAction: true },
  { permission: "Edit", isAction: true },
];

const TrainingCompletionModal = ({
  TrainingCompletionModalOpen,
  setTrainingCompletionModalOpen,
  selectedRow,
  setSelectedRow,
  setTrainingCompletionEmpList,
  trainingCompletionEmpList,
  populateTable,
}) => {
  const { control, watch, setValue, handleSubmit, formState } = useForm({
    defaultValues: { attendant: null, remark: "" },
  });
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const selectedAttendant = watch("attendant");

  useEffect(() => {
    if (!selectedAttendant) return;

    setTableData((prev) => {
      if (!Array.isArray(prev)) return [];

      const alreadyAdded = prev?.some(
        (item) =>
          item?.id === selectedAttendant?.id ||
          item?.id === selectedAttendant?.value,
      );

      if (alreadyAdded) return prev;

      return [
        ...prev,
        {
          Attendant: selectedAttendant?.label,
          id: selectedAttendant?.id || selectedAttendant?.value,
        },
      ];
    });

    setValue("attendant", null);
  }, [selectedAttendant, setValue]);

  const renderActionsEmp = (row) => (
    <span className=" gap-2 items-center">
      {userActions.map(
        (actions, i) =>
          actions.isAction &&
          actions.permission === "Edit" && (
            <spna>
              <CheckBoxField
                defaultValue={true}
                control={control}
                defaultChecked={true}
                name={`checkbox_${String(row?.id)}`}
              />
            </spna>
            // <DeleteIcon
            //   key={i}
            //   sx={{ color: "#D11A2A", cursor: "pointer" }}
            //   onClick={() => handleDeleteEmployee(row)}
            // />
          ),
      )}
    </span>
  );
  // const onSubmit = (formData) => {
  //   console.log("Form errors:", formState?.errors);

  //   console.log("onsubmit");
  //   // if (tableData.length === 0) return;
  //   setOpenConfirmModal(true);
  // };
  const onSubmit = (formData) => {
    const selectedEmployees = trainingCompletionEmpList.filter(
      (emp) => emp?.isChecked === true,
    );

    if (selectedEmployees.length === 0) {
      alert("Please select at least one employee");
      return;
    }

    setOpenConfirmModal(true);
  };
  const handleFinalSubmit = () => {
    const formData = watch();

    const employeeList = trainingCompletionEmpList
      .filter((emp) => emp?.isChecked)
      .map((emp) => emp.id);

    if (employeeList.length === 0) {
      alert("Please select at least one employee");
      return;
    }

    const payload = {
      employee: employeeList,
      trainingId: selectedRow?.["Training Id"],
      trainingScheduleId: selectedRow?.["Training Schedule Id"],
      remark: formData?.remark || "",
    };

    setOpenBackdrop(true);

    saveTrainingScheduleCompletion(payload)
      .then((res) => res?.data)
      .then((res) => {
        if (res?.statusCode === 200 || res?.statusCode === 201) {
          successAlert(res?.message);
          setTrainingCompletionModalOpen(false);
          setSelectedRow(null);
          populateTable();
        }
      })
      .finally(() => setOpenBackdrop(false));
  };
  // const handleFinalSubmit = () => {
  //   let employeeList = tableData?.map((obj) => {
  //     return obj?.id;
  //   });
  //   let obj = {
  //     employee: employeeList,
  //     trainingId: selectedRow?.["Training Id"],
  //     trainingScheduleId: selectedRow?.["Training Schedule Id"],
  //   };
  //   // const payload = {
  //   //   trainingName: selectedTraining.label,
  //   //   trainingType: selectedTraining.trainingType.label,
  //   //   date: "11-02-2026",
  //   //   attendants: tableData.map((t) => t.Attendant),
  //   //   remark: watch("remark") || "",
  //   // };
  //   setOpenConfirmModal(false);
  //   // setTrainingScheduleModalOpen(false);
  //   setOpenBackdrop(true);
  //   setOpenConfirmModal(false);
  //   saveTrainingScheduleCompletion(obj)
  //     .then((response) => response.data)
  //     .then((res) => {
  //       if (res.statusCode === 201 || res.statusCode === 200) {
  //         setTrainingCompletionModalOpen(false);
  //         setSelectedRow(null);
  //         // successAlert(res?.message);
  //         setOpenBackdrop(false);
  //         setTableData([]);
  //         setOpenConfirmModal(false);
  //         populateTable();
  //         // reset();
  //       }
  //     })
  //     .catch((error) => {
  //       // errorAlert(error.message);
  //       setOpenBackdrop(false);
  //     });
  // };
  // const renderInput = (row, index, header) => {
  //   return (
  //     <>
  //       {/* {header === "Status" && (
  //         <button
  //           className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
  //                    ${
  //                      row?.Status === true
  //                        ? "text-customGreen border-customGreen"
  //                        : "text-customRed border-customRed"
  //                    }`}
  //           type="button"
  //         >
  //           {row?.Status === true ? "Active" : "InActive"}
  //         </button>
  //       )} */}
  //     </>
  //   );
  // };
  return (
    // <form onSubmit={handleSubmit(onSubmit)}>
    <>
      {" "}
      <Modal open={TrainingCompletionModalOpen}>
        <Box sx={modalStyle}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-lg font-semibold">Training Completion</h2>
              <button
                onClick={() => {
                  setTrainingCompletionModalOpen(false);
                  setSelectedRow(null);
                }}
                className="text-gray-500 hover:text-red-500"
                type="button"
              >
                <CloseModalIcon />
              </button>
            </div>

            <div className="mt-3 p-3 border rounded bg-gray-200 text-sm">
              <div className="grid grid-cols-3 gap-2">
                <p>
                  <span className="font-semibold">Training Name : </span>
                  <span>{selectedRow?.["Training Name"]}</span>
                </p>
                <p>
                  <span className="font-semibold">Date : </span>
                  <span>{selectedRow?.["Training Date"]}</span>
                </p>
                <p>
                  <span className="font-semibold">Mode : </span>
                  <span>{selectedRow?.Mode} </span>
                </p>
                <p>
                  <span className="font-semibold">Trainer Name : </span>
                  <span>{selectedRow?.["Trainer Name"]} </span>
                </p>
              </div>
            </div>

            {/* <div className="mt-4 w-1/3">
              <SearchDropdown
                dataArray={trainingCompletionEmpList}
                control={control}
                name="attendant"
                placeholder="Select Attendant"
                isClearable
                isSearchable
                searchIcon
                handleInputChange={() => {}}
                onChange={() => {}}
              />
            </div> */}

            {/* <div className="mt-4 h-[300px] md:w-[50%]">
            {tableData.length > 0 ? (
              <CommonTransactionTable
                dataResult={tableData}
                highlightRow={false}
                renderActions={renderActionsEmp}
                SelectCheckbox={true}
                removeHeaders="id"
                // renderInput={renderInput}
              />
            ) : (
              <div className="flex justify-center  font-bold text-gray-600">
                No Records Found...
              </div>
            )}
          </div> */}
            <div className="mt-4 h-[300px] md:w-[40%]">
              {trainingCompletionEmpList.length > 0 ? (
                <CommonDynamicTableNew
                  setDataResult={setTrainingCompletionEmpList}
                  SelectCheckbox={true}
                  enableSelectAll={true}
                  dataResult={trainingCompletionEmpList}
                  highlightRow={false}
                  // renderActions={renderActionsEmp}
                  // SelectCheckbox={true}
                  removeHeaders={[
                    "id",
                    "value",
                    "label",
                    "isChecked",
                    "employeeId",
                  ]}
                  tableClass={""}
                  // SelectCheckbox={true}
                  // renderInput={renderInput}
                />
              ) : (
                <div className="flex justify-center  font-bold text-gray-600">
                  No Records Found...
                </div>
              )}
            </div>

            <div className="flex gap-2 mt-6 justify-between bottom-0">
              <div className="w-[40%]">
                <InputField label="Remark" name="remark" control={control} />
              </div>

              <CommonButton
                label="Submit"
                type="submit"
                className="saveButton px-6 py-2 bg-green-700 text-white text-base"
              />
            </div>
          </form>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openConfirmModal}
        confirmationHandleClose={() => setOpenConfirmModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to submit training completion?"
        confirmationSubmitFunc={handleFinalSubmit}
        confirmationButtonMsg="Submit"
      />
    </>
    // </form>
  );
};

export default TrainingCompletionModal;